export const shareDataMixin = {
  methods: {
    mapByName (name) {
      this.$store.dispatch('data/kvList', name)
      const ret = {}
      for (const item of this.$store.state.data[name] || []) {
        ret[item.id] = item.name
      }
      return ret
    },
    codeMapByName (name) {
      this.$store.dispatch('data/kvList', name)
      const ret = {}
      for (const item of this.$store.state.data[name] || []) {
        ret[item.code] = item.name
      }
      return ret
    }
  },
  computed: {
    brandNameMap () {
      return this.mapByName('BrandModel')
    },
    insuranceCompanyMap () {
      return this.mapByName('INSURANCE_COMPANY')
    },
    payMethodLabelMap () {
      return this.codeMapByName('PAY_METHOD')
    },
    procedureTypeMap () {
      return this.mapByName('ProcedureType')
    },
    sheetMetalDamageDegreeMap () {
      return this.mapByName('SheetMetalDamageDegree')
    },
    paintDamageDegreeMap () {
      return this.mapByName('PaintDamageDegree')
    },
    brandMap () {
      return this.mapByName('BrandModel')
    },
    activeMiddleProcedureMap () {
      return this.mapByName('ActiveMiddleProcedure')
    },
    technicianTypeMap () {
      return this.mapByName('TechnicianType')
    },
    procedureMap () {
      const ret = {}
      this.$store.dispatch('procedure/middleProcedureList')
      for (const procedure of this.$store.state.procedure.middleProcedureList) {
        ret[procedure.id] = procedure
      }
      return ret
    },
    teamMap () {
      const ret = {}
      this.$store.dispatch('team/all')
      for (const team of this.$store.state.team.teamList) {
        ret[team.id] = team
      }
      return ret
    },
    consultantMap () {
      const ret = {}
      const consultants = this.$store.state.data.ConsultantsOfShop
      for (const shop of consultants || []) {
        for (const consultant of shop.consultants || []) {
          ret[consultant.id] = consultant.name
        }
      }
      return ret
    },
    partsCoeMap () {
      const ret = {}
      this.$store.dispatch('partsCoe/all')
      for (const partsCoe of this.$store.state.partsCoe.partsCoeList) {
        ret[partsCoe.partsId] = partsCoe
      }
      return ret
    },
    myOrgan () {
      const level = this.$store.state.user.level
      if (!level) return null
      if (level === 'WORKSHOP') {
        return this.$store.state.user.workshop
      } else {
        return this.$store.state.shop
      }
    },
    isRoot () {
      return this.$store.state.user.level === 'ROOT'
    },
    OutsideReworkMap () {
      return this.mapByName('OUTSIDE_REWORK_REASON')
    }
  }
}
